// customers
import login from './pages/login/login.vue'
import home from './pages/home/home.vue'
import users from './pages/users/users.vue'
import payments from './pages/payments/payments.vue'
import pay_type from './pages/pay_type/pay_type.vue'
import companies from './pages/companies/companies.vue'
import products from './pages/products/products.vue'


export const Routes = [
    {
        path: '/',
        redirect: '/login',
    },

    // customers
    {
        path: '/login',
        name: "login",
        component: login,
    },
    {
        path: '/home',
        name: "home",
        component: home,
    },
    {
        path: '/users',
        name: "users",
        component: users,
    },
    {
        path: '/payments',
        name: "payments",
        component: payments,
    },
    {
        path: '/pay_type',
        name: "pay_type",
        component: pay_type,
    },
    {
        path: '/companies',
        name: "companies",
        component: companies,
    },
    {
        path: '/products',
        name: "products",
        component: products,
    },
 
   
]